import {connect} from '@modifi/redux'
import {path} from 'ramda'

import {aCloseDialog} from '@modifi/plugin-dialogs'
import SpvRemovalDialog from './SpvRemovalDialog'
import {
  aEnsureAvailableRefinancingPartners,
  selectAvailableRefinancingPartnersByTransactionId,
  selectAvailableRefinancingPartnersHasError,
} from '../../../../modules/available-refinancing-partners'

import {
  aDeleteTransaction,
  selectDeleteErrorMessage,
  selectDeletePending,
} from '../../../../modules/delete-transaction'

const getTransactionId = path(['params', 'id'])

const mapStateToProps = (state, ownProps) => {
  const transactionId = getTransactionId(ownProps)
  return {
    refinancingPartners: selectAvailableRefinancingPartnersByTransactionId(state)(transactionId),
    fetchError: selectAvailableRefinancingPartnersHasError(state)(transactionId),
    isDeleting: selectDeletePending(state),
    deleteError: selectDeleteErrorMessage(state),
  }
}

const mapDispatchToProps = {
  fetchRefinancingPartners: aEnsureAvailableRefinancingPartners,
  deleteTransaction: aDeleteTransaction,
  closeDialog: aCloseDialog,
}

export const DIALOG_NAME = 'dialog-spv-removal'

export default connect(mapStateToProps, mapDispatchToProps)(SpvRemovalDialog)
